<template> 
    <tr>
        <td> {{ this.rigaEntita.Identificativo }} </td>
        <td> {{ this.rigaEntita.Descrizione }} </td>
        <td> {{ this.rigaEntita.DescrSito }} </td>
        <td> {{ this.rigaEntita.IndirSito }} </td>
        <td> {{ this.rigaEntita.DescrUnita }} </td>
        <td> {{ this.rigaEntita.DescrReparto }} </td>
        <td> {{ this.rigaEntita.DescrComparto }} </td>
        <td> <router-link :to="{name : 'SchedaEntita', params : { idEntita : this.rigaEntita.IdEntita} }"> {{ this.rigaEntita.CodiceEntita}}</router-link> </td>       
    </tr>
</template>

<script>

export default {
    name: "RigaGrigliaEntita",
    props: {
        rigaEntita: Object       
    }
} 
</script>
